import React, { Component } from 'react';
import { Nav, Navbar, Card, Button, Row, Col } from 'react-bootstrap';
import { Form, Validator } from '../../widgets';
import ColorPicker from './ColorPicker';
import { GEO_FIELD_TYPE, geoCustom } from '../../../constants';
import Datetime from 'react-datetime';
import "../../../../assets/css/react-datetime.css";
import { FormValidator } from '../../../helpers/form-validator';
import shp from 'shpjs';
import { kml } from '@tmcw/togeojson';
import { uuid } from '../../../helpers/common';
import * as shapefile from 'shapefile';
import { toastError, toastSnackbar } from '../../../actions/toast';
import store from '../../../store';

export default class DrawingOptions extends Component {
    manager = null;
    color = {
        strokeColor: '#FFF',
        fillColor: '#03ff6d33'
    };

    title = {
        name: 'Untitled',
        type: 2,
        disableType: false,
        cropName: "",
        customerId: null,
        startDate: null,
        variety: "",
        farmGeoConfig: {}
    };
    state = {
        ...this.color,
        isOpen: false,
        title: this.title,
        before: null,
        showDrawingTool: true,
        isDelete: true,
        isShapeSave: false,
        farmCustomerList: [],
        geoConfig: {},
        isGeoConfig: false
    };

    handleFarmType = this.handleFarmType.bind(this);
    handleChangeDate = this.handleChangeDate.bind(this);
    handleChooseFile = this.handleChooseFile.bind(this);
    handleFileChange = this.handleFileChange.bind(this);
    getImportedShapeFilesGeo = this.getImportedShapeFilesGeo.bind(this);

    getValidationRules() {
        return new FormValidator([
            {
                field: 'startDate',
                method: "isSelected",
                validWhen: true,
                message: 'Start date is required'
            },
            {
                field: 'startDate',
                method: "isMoment",
                validWhen: true,
                message: 'Start date is required'
            }
        ])
    }

    componentDidMount() {
        if (this.props.isReplayOpen)
            store.dispatch(toastSnackbar('Please close snail trail to edit places.'));

        const state = store.getState();

        this.validator = this.getValidationRules();
        this.submitted = false;
        this.setState({ validation: this.validator.valid() });

        this.drawing = this.props.drawingTools;
        this.drawing.setColor(this.color).openTools().setNonDrawingMode()
            .addListener('shape_selected', 'tools', ({ options }) => options ? this.setState(options) : null);

        const farmCustomers = state.customer.farmCustomerList.payload;
        const farmCustomerList = farmCustomers.map((e) => ({
            value: e.customer_uuid,
            label: e.customer_name

        }))
        this.setState({ farmCustomerList: farmCustomerList })

        const geoConfig = state.geo.geo_config;

        const enableGeoConfig = geoConfig && geoConfig.load_geo_params ?
            geoConfig.load_geo_params.visible : false;
        const loadGeoParams = geoConfig.load_geo_params && geoConfig.load_geo_params.configuration && geoConfig.load_geo_params.configuration.geo_custom_params ?
            geoConfig.load_geo_params.configuration.geo_custom_params : geoCustom.geo_custom_params;
        this.setState({ isGeoConfig: enableGeoConfig, geoConfig: loadGeoParams });
    }


    componentDidUpdate(prevProps) {
        if (prevProps.drawingTools.newShapeCount === 0 && !this.state.showDrawingTool) this.setState({ showDrawingTool: true });
        else if (prevProps.drawingTools.newShapeCount !== 0 && this.state.showDrawingTool) this.setState({ showDrawingTool: false });
    }

    handleGeoConfig(key) {
        this.setState((prevState) => {
            const geoConfig = prevState.geoConfig.map((item) =>
                item.key === key ? { ...item, visible: false } : item
            );
            return { geoConfig };
        });
    }

    setTitle(title) {
        this.setState({ title, validation: this.validator.valid() });
    }

    handleFarmType(e) {
        this.setState({
            title: {
                ...this.state.title,
                type: e ? e.value : 2
            }
        })
    }

    handleChangeDate(event) {
        this.setState({
            title: {
                ...this.state.title,
                startDate: event
            }
        });
    }

    handleClick = name => {
        if (name === "delete") {
            this.drawing.deleteSelectedShape();
            this.setState({ isDelete: true })
        }
        else if (name === "save") {
            if (this.state.title.name === "Untitled") return this.regionTittleToggle(true);
            return this.saveGeoRegion();
        }
        else if (name === "discard") {
            this.props.onDiscard();
            if (this.drawing.isEditable) {
                this.setState({ isDelete: false })
            } else {
                this.setState({ isDelete: true })
            }
        }
        else if (name === "close") this.props.onClose();
        else if (name === "title:toggle") this.regionTittleToggle(false);
        else if (name === "title:save") {
            const validation = this.validator.validate(this.state.title);
            this.setState({ validation });
            this.submitted = true;

            if (validation.isValid) {
                // this.drawing.emit("title_save", { title: this.state.title });
                this.setState({ isOpen: !this.state.isOpen, before: null });
            }

            this.saveGeoRegion();
        }
    }

    saveGeoRegion = () => {
        const validation = this.validator.validate(this.state.title);
        this.setState({ validation });
        this.submitted = true;

        if (validation.isValid) {
            this.drawing.emit("save", { title: { ...this.state.title, ...{ others: { ...this.state.title.farmGeoConfig } } } });
        }
    }

    regionTittleToggle = (isShapeSave) => {
        if (!this.state.isOpen) this.setState({ isOpen: !this.state.isOpen, before: this.state.title, isShapeSave: isShapeSave });
        else this.setState({ isOpen: !this.state.isOpen, title: this.state.before, isShapeSave: isShapeSave });
    }

    handleColor = (color, name) => {
        const hexCode = this.convertRGBToHex(color.rgb);
        this.setState({ [name]: hexCode });
        this.drawing.setColor({ [name]: hexCode });
    }

    convertRGBToHex(rgba) {
        const r = rgba.r.toString(16), g = rgba.g.toString(16), b = rgba.b.toString(16),
            a = (((rgba.a).toFixed(1)) * 255).toString(16);
        const validateRgb = value => {
            value = (value.toString().length > 2) ? value.toString().substring(0, 2) : value;
            value = (value.toString().length !== 2) ? ("0" + value) : value;
            return value;
        }
        const color = [r, g, b, a].map(val => validateRgb(val));
        return ('#' + color[0] + color[1] + color[2] + color[3]);
    }

    handleChange = e => {
        this.setState({ title: { ...this.state.title, [e.target.name]: e.target.value } });
    }

    geoConfigHandleChange = (e, key) => {
        const { value } = e.target;
        this.setState(prevState => ({
            title: {
                ...prevState.title,
                farmGeoConfig: {
                    ...prevState.title.farmGeoConfig,
                    [key]: value
                }
            }
        }));
    }
    handleSelect = (e, name) => {
        if (e) this.setState({ title: { ...this.state.title, [name]: e.value } });
        else this.setState({ title: { ...this.state.title, [name]: null } })
    }

    handleChooseFile() {
        const input = document.querySelector("#file-upload");
        if (input) input.click();
    }

    handleFileChange(e) {
        e.preventDefault();
        if (!(e.target && e.target.files && e.target.files.length > 0)) return;
        const file = e.target.files[0];
        const reader = new FileReader();
        const fileParts = file.name.split(".");
        const fileExtension = fileParts.length > 0 ? fileParts[fileParts.length - 1] : null;

        if (file.type === "application/zip") {
            reader.onload = e => {
                shp(e.target.result).then((geojson) => {
                    this.getImportedShapeFilesGeo(geojson)
                }).catch(() => this.drawing.emit("unsupported-file", "File must contain *.shp file"));;
            };
            reader.readAsArrayBuffer(file);
        } else if (file.type === "application/vnd.google-earth.kml+xml" || fileExtension === "kml") {
            reader.onload = e => {
                const geojson = kml(new DOMParser().parseFromString(e.target.result, "text/xml"));
                this.getImportedShapeFilesGeo(geojson);
            };
            reader.readAsText(file);
        } else if (fileExtension === "shp") {
            const me = this;
            reader.onload = e => {
                shapefile.open(e.target.result)
                    .then(source => source.read()
                        .then((result) => {
                            if (result.done) return;
                            me.getImportedShapeFilesGeo(result.value)
                        }))
                    .catch(() => this.drawing.emit("unsupported-file"));
            }

            reader.readAsArrayBuffer(file);
        } else this.drawing.emit("unsupported-file");
    }

    getImportedShapeFilesGeo(data) {
        const shapeObj = this.drawing.getShapeInstance();

        if (!data) return;

        const fileName = data.fileName ? data.fileName : null;
        if (fileName && fileName.length > 0 && this.state.title.name === "Untitled") {
            this.setState({ title: { ...this.state.title, name: fileName } });
            this.drawing.emit("title_save", { title: this.state.title });
        }

        const addShapes = (geoData) => {
            const { geometry, properties } = geoData;
            const shapeId = uuid();

            const options = {};

            if (geometry.type === "Polygon") {
                const geoProperties = {
                    strokeColor: '#FFF',
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: '#03FF6D33',
                    fillOpacity: 1,
                    zIndex: 1
                };

                if (properties.stroke) geoProperties.strokeColor = properties.stroke;
                if (properties["stroke-opacity"]) geoProperties.strokeOpacity = properties["stroke-opacity"];
                if (properties["stroke-width"]) geoProperties.strokeWeight = properties["stroke-width"];
                if (properties.fill) geoProperties.fillColor = properties.fill;
                if (properties["fill-opacity"]) geoProperties.fillOpacity = properties["fill-opacity"];

                const location = geometry.coordinates[0].map(e => ({ lng: e[0], lat: e[1] }));

                options.properties = geoProperties;
                options.location = location;
                options.type = "polygon";
            } else if (geometry.type === "Point") {
                const location = {
                    lng: geometry.coordinates[0],
                    lat: geometry.coordinates[1]
                }
                options.location = [location];
                options.properties = {
                    icon: null,
                    zIndex: 1
                };
                options.type = "marker";
            } else if (geometry.type === "LineString") {
                const geoProperties = {
                    strokeColor: "#FFF",
                    strokeOpacity: 1,
                    strokeWeight: 3,
                    zIndex: 1
                };

                if (properties.stroke) geoProperties.strokeColor = properties.stroke;
                if (properties["stroke-opacity"]) geoProperties.strokeOpacity = properties["stroke-opacity"];
                if (properties["stroke-width"]) geoProperties.strokeWeight = properties["stroke-width"];

                const location = geometry.coordinates.map(e => ({ lng: e[0], lat: e[1] }));

                options.properties = geoProperties;
                options.location = location;
                options.type = "polyline";
            } else if (geometry.type === "Circle") {
                const geoProperties = {
                    strokeColor: '#FFF',
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: '#03FF6D33',
                    fillOpacity: 1,
                    zIndex: 1
                };

                if (properties.stroke) geoProperties.strokeColor = properties.stroke;
                if (properties["stroke-opacity"]) geoProperties.strokeOpacity = properties["stroke-opacity"];
                if (properties["stroke-width"]) geoProperties.strokeWeight = properties["stroke-width"];
                if (properties.fill) geoProperties.fillColor = properties.fill;
                if (properties["fill-opacity"]) geoProperties.fillOpacity = properties["fill-opacity"];

                const location = {
                    lng: geometry.coordinates[0],
                    lat: geometry.coordinates[1]
                }
                options.location = [location];

                options.properties = geoProperties;
                options.location = location;
                options.type = "circle";
            } else if (geometry.type === "Rectangle") {
                const geoProperties = {
                    strokeColor: '#FFF',
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: '#03FF6D33',
                    fillOpacity: 1,
                    zIndex: 1
                };

                if (properties.stroke) geoProperties.strokeColor = properties.stroke;
                if (properties["stroke-opacity"]) geoProperties.strokeOpacity = properties["stroke-opacity"];
                if (properties["stroke-width"]) geoProperties.strokeWeight = properties["stroke-width"];
                if (properties.fill) geoProperties.fillColor = properties.fill;
                if (properties["fill-opacity"]) geoProperties.fillOpacity = properties["fill-opacity"];

                const location = geometry.coordinates[0].map(e => ({ lng: e[0], lat: e[1] }));

                options.properties = geoProperties;
                options.location = location;
                options.type = "rectangle";
            } else {
                store.dispatch(toastError('Could not recognize content.'));
            }

            const shape = shapeObj.createShape({
                id: shapeId,
                ...options
            });
            if (!shape || !options.type) return;

            shape.type = options.type;
            shape.name = properties.name || properties.FIELD_NAME;

            if (shape.name && shape.name.length > 0 && this.state.title.name === "Untitled") {
                this.setState({ title: { ...this.state.title, name: shape.name } });
                this.drawing.emit("title_save", { title: this.state.title });
            }

            this.drawing.addShapeToList(shape);
            this.drawing._addShapeEventListener(shape);
        }

        // add individual geometry 
        const addGeometry = (geoData) => {
            if (geoData.geometry && Array.isArray(geoData.geometry.geometries)) {
                for (const item of geoData.geometry.geometries) addShapes({ geometry: item || {}, properties: geoData.properties || {} });
            } else addShapes(geoData);
        }

        if (data.features && Array.isArray(data.features)) for (const item of data.features) addGeometry(item)
        else addGeometry(data);

        this.drawing.showShapes();
        this.drawing.setBounds(this.drawing.editableShapeGroupId);
        return this;
    }

    componentWillUnmount() {
        this.drawing.removeListenerByName('tools');
        this.drawing.closeTools();
    }

    handleFocus = e => {
        if (e.target.value === "Untitled") return this.setState({ title: { ...this.state.title, name: "" } });
    }

    geoConfigElements() {
        return this.state.isGeoConfig ? this.state.geoConfig.map((it, index) =>
            <Form.Group key={`${it.key}-${index}`}>
                <Form.Label>{it.label}</Form.Label>
                <Form.Control size="sm"
                    name={it.key}
                    type={it.type}
                    placeholder={it.placeholder}
                    value={this.state.title.farmGeoConfig[it.key] || ""}
                    autoComplete="none"
                    onChange={(e) => this.geoConfigHandleChange(e, it.key)} />
            </Form.Group>) : null;

    }

    render() {
        const validation = this.submitted ? this.validator.validate(this.state.title) : this.state.validation;
        return (
            <div className="drawing-inner">
                <div className="d-flex">
                    <Navbar expand="sm" className="drawing-tools">
                        <Nav className="mr-auto">
                            <ColorPicker color={this.state.fillColor}
                                onChange={color => this.handleColor(color, "fillColor")} className="px-2">
                                {({ onClick }) =>
                                    <Nav.Link className="color-picker" onClick={onClick} title="Background color">
                                        <i className="fa fa-paint-brush" aria-hidden="true" />
                                        <div className="color" style={{ background: this.state.fillColor }} />
                                    </Nav.Link>}
                            </ColorPicker>
                            <ColorPicker color={this.state.strokeColor}
                                onChange={color => this.handleColor(color, "strokeColor")} className="px-2">
                                {({ onClick }) =>
                                    <Nav.Link className="color-picker" onClick={onClick} title="Stroke color">
                                        <i className="fa fa-pencil-square-o" aria-hidden="true" />
                                        <div className="color" style={{ background: this.state.strokeColor }} />
                                    </Nav.Link>}
                            </ColorPicker>
                            <Nav.Link title="Save" disabled={this.state.showDrawingTool} onClick={this.handleClick.bind(this, 'save')} className="px-2">
                                <i className="fa fa-floppy-o" aria-hidden="true"></i> Save
                            </Nav.Link>
                            <div className="splitter" />
                            <Nav.Link title="Delete shape" disabled={this.state.showDrawingTool} onClick={this.handleClick.bind(this, 'delete')} className="px-2">
                                <i className="fa fa-trash-o" aria-hidden="true"></i> Delete
                            </Nav.Link>
                            <Nav.Link title="Discard" onClick={this.handleClick.bind(this, 'discard')} className="px-2">
                                <i className="fa fa-retweet" aria-hidden="true"></i> Discard
                            </Nav.Link>
                            <Nav.Link title="Close" onClick={this.handleClick.bind(this, 'close')} className="px-2">
                                <i className="fa fa-times" aria-hidden="true"></i> Close
                            </Nav.Link>
                        </Nav>
                    </Navbar>
                    <Navbar expand="sm" className="drawing-title">
                        <Nav>
                            <Nav.Link title={this.state.title.name} onClick={this.handleClick.bind(this, 'title:toggle')}>
                                {this.state.title.name}
                            </Nav.Link>
                            <Nav.Link title="Edit" onClick={this.handleClick.bind(this, 'title:toggle')} className="link-edit">
                                <i className="fa fa-pencil float-right" aria-hidden="true"></i>
                            </Nav.Link>
                        </Nav>
                    </Navbar>
                </div>
                {this.state.isOpen && <div className="w-100">
                    <Card className="drawing-title-popup">
                        {/* <Card.Header>
                            <i className="fa fa-check" title="Save" aria-hidden="true"
                                onClick={this.handleClick.bind(this, 'title:save')} />
                            <i className="fa fa-times" title="Close" aria-hidden="true"
                                onClick={this.handleClick.bind(this, 'title:toggle')} />
                        </Card.Header> */}
                        <Card.Body>
                            <Form.Group>
                                <Form.Label>Name</Form.Label>
                                <Form.Control size="sm" type="text" value={this.state.title.name}
                                    name="name" onFocus={this.handleFocus} onChange={this.handleChange} autoComplete="none" />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Crop Name</Form.Label>
                                <Form.Control size="sm" type="text" value={this.state.title.cropName} placeholder="Crop Name"
                                    name="cropName" onChange={this.handleChange} autoComplete="none" />
                            </Form.Group>

                            <Form.Group >
                                <Form.Label>Variety</Form.Label>
                                <Form.Control size="sm"
                                    name="variety"
                                    type="text"
                                    placeholder="Variety"
                                    value={this.state.title.variety}
                                    autoComplete="none"
                                    onChange={this.handleChange} />
                            </Form.Group>

                            <Form.Group>
                                <Validator validation={validation.startDate}>
                                    <Form.Label htmlFor="startDate">Start Date</Form.Label>
                                    <Datetime id="startDate" placeholder="Select start date" name="startDate" closeOnSelect={true}
                                        onChange={this.handleChangeDate} value={this.state.title.startDate}
                                        selected={this.state.title.startDate} />
                                    <Validator.Text />
                                </Validator>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Type</Form.Label>
                                <Form.Select id="type" placeholder="Choose a type" name="farmType" disabled={this.state.title.disableType}
                                    value={this.state.title.type} onChange={this.handleFarmType}
                                    options={GEO_FIELD_TYPE.map(e => ({ value: e.id, label: e.name }))}
                                    sortType="asc" />
                            </Form.Group>
                            {this.state.title.type === 2 &&
                                <Form.Group>
                                    <Form.Label>Customer Name</Form.Label>
                                    <Form.Select
                                        id="customerId"
                                        placeholder="Select Customer Name"
                                        name="customerId"
                                        onChange={(e) => this.handleSelect(e, "customerId")}
                                        value={this.state.title.customerId}
                                        options={this.state.farmCustomerList}
                                    />
                                </Form.Group>}
                            {this.geoConfigElements()}
                            <Row className="m-0">
                                <Col className="p-0 pr-1">
                                    <Button variant="danger" size="sm" className="w-100" onClick={this.handleClick.bind(this, 'title:toggle')} >Cancel</Button>
                                </Col>
                                <Col className="p-0 pl-1">
                                    <Button variant="primary" size="sm" className="w-100" onClick={this.handleClick.bind(this, 'title:save')} >Done</Button>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </div>}
            </div>
        )
    }
}
